export default __webpack_public_path__ + "static/media/ROTAFOLIO_ASPROS_ZH.afd450d9.pdf";